/* src/app/indirect-rate/indirect-rate-rule/indirect-rate-rule-container/indirect-rate-rule-container.component.scss */
/*# sourceMappingURL=indirect-rate-rule-container.component.css.map */
